import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  en: {
    nav_services: "Services", nav_home_collection: "Home Collection", nav_about: "About",
    nav_why: "Why Us", nav_reviews: "Reviews", nav_faq: "FAQ", nav_contact: "Contact",
    nav_wellness: "Wellness", nav_hospitals: "Hospitals", nav_careers: "Careers",
    call_now: "Call Now", whatsapp: "WhatsApp", get_directions: "Get Directions",
    book_appointment: "Book Appointment", book_home_collection: "Book Home Collection",
    hero_title: "Trusted Diagnostic Laboratory in Phillaur",
    hero_sub: "Fast, Accurate & Affordable Blood Testing with Home Sample Collection.",
    services_label: "Our Services", services_title: "Laboratory Tests We Offer",
    services_sub: "From routine checkups to specialised diagnostics, all under one roof.",
    search_placeholder: "Search your laboratory test…",
    hc_label: "Convenience at Home", hc_title: "Home Blood Collection",
    hc_text: "Don't waste time waiting. Our experienced technicians collect your blood sample safely from the comfort of your home.",
    how_label: "Simple Process", how_title: "How It Works",
    step1: "Book Appointment", step2: "Home Collection", step3: "Laboratory Testing", step4: "Receive Digital Report",
    about_label: "About Us", about_title: "Precision You Can Trust",
    why_label: "Why DOABA", why_title: "Why Choose DOABA Diagnostics",
    reviews_label: "Testimonials", reviews_title: "What Our Patients Say",
    faq_label: "FAQ", faq_title: "Frequently Asked Questions",
    contact_label: "Get In Touch", contact_title: "Visit or Contact Us",
    footer_hours: "Working Hours", footer_quick: "Quick Links", footer_contact: "Contact",
    submit: "Submit", sending: "Sending...", share_review: "Share Your Review",
  },
  hi: {
    nav_services: "सेवाएं", nav_home_collection: "होम कलेक्शन", nav_about: "हमारे बारे में",
    nav_why: "क्यों चुनें", nav_reviews: "समीक्षाएं", nav_faq: "सवाल-जवाब", nav_contact: "संपर्क",
    nav_wellness: "वेलनेस", nav_hospitals: "अस्पताल", nav_careers: "करियर",
    call_now: "कॉल करें", whatsapp: "व्हाट्सएप", get_directions: "दिशा-निर्देश",
    book_appointment: "अपॉइंटमेंट बुक करें", book_home_collection: "होम कलेक्शन बुक करें",
    hero_title: "फिल्लौर की भरोसेमंद डायग्नोस्टिक लैब",
    hero_sub: "होम सैंपल कलेक्शन के साथ तेज़, सटीक और किफायती ब्लड टेस्टिंग।",
    services_label: "हमारी सेवाएं", services_title: "हमारे लैबोरेटरी टेस्ट",
    services_sub: "नियमित जांच से लेकर विशेष डायग्नोस्टिक्स तक, सब एक ही छत के नीचे।",
    search_placeholder: "अपना लैब टेस्ट खोजें…",
    hc_label: "घर पर सुविधा", hc_title: "होम ब्लड कलेक्शन",
    hc_text: "इंतज़ार में समय बर्बाद न करें। हमारे अनुभवी तकनीशियन आपके घर से सुरक्षित रूप से ब्लड सैंपल लेते हैं।",
    how_label: "आसान प्रक्रिया", how_title: "यह कैसे काम करता है",
    step1: "अपॉइंटमेंट बुक करें", step2: "होम कलेक्शन", step3: "लैबोरेटरी टेस्टिंग", step4: "डिजिटल रिपोर्ट प्राप्त करें",
    about_label: "हमारे बारे में", about_title: "जिस पर आप भरोसा कर सकते हैं",
    why_label: "क्यों DOABA", why_title: "DOABA डायग्नोस्टिक्स क्यों चुनें",
    reviews_label: "प्रशंसापत्र", reviews_title: "हमारे मरीज़ क्या कहते हैं",
    faq_label: "सवाल-जवाब", faq_title: "अक्सर पूछे जाने वाले प्रश्न",
    contact_label: "संपर्क करें", contact_title: "हमसे मिलें या संपर्क करें",
    footer_hours: "कार्य समय", footer_quick: "त्वरित लिंक", footer_contact: "संपर्क",
    submit: "सबमिट करें", sending: "भेजा जा रहा है...", share_review: "अपनी समीक्षा साझा करें",
  },
  pa: {
    nav_services: "ਸੇਵਾਵਾਂ", nav_home_collection: "ਹੋਮ ਕਲੈਕਸ਼ਨ", nav_about: "ਸਾਡੇ ਬਾਰੇ",
    nav_why: "ਕਿਉਂ ਚੁਣੋ", nav_reviews: "ਸਮੀਖਿਆਵਾਂ", nav_faq: "ਸਵਾਲ-ਜਵਾਬ", nav_contact: "ਸੰਪਰਕ",
    nav_wellness: "ਵੈੱਲਨੈੱਸ", nav_hospitals: "ਹਸਪਤਾਲ", nav_careers: "ਕਰੀਅਰ",
    call_now: "ਕਾਲ ਕਰੋ", whatsapp: "ਵਟਸਐਪ", get_directions: "ਰਾਹ ਵੇਖੋ",
    book_appointment: "ਅਪੌਇੰਟਮੈਂਟ ਬੁੱਕ ਕਰੋ", book_home_collection: "ਹੋਮ ਕਲੈਕਸ਼ਨ ਬੁੱਕ ਕਰੋ",
    hero_title: "ਫਿਲੌਰ ਦੀ ਭਰੋਸੇਯੋਗ ਡਾਇਗਨੋਸਟਿਕ ਲੈਬ",
    hero_sub: "ਹੋਮ ਸੈਂਪਲ ਕਲੈਕਸ਼ਨ ਨਾਲ ਤੇਜ਼, ਸਹੀ ਅਤੇ ਕਿਫਾਇਤੀ ਬਲੱਡ ਟੈਸਟਿੰਗ।",
    services_label: "ਸਾਡੀਆਂ ਸੇਵਾਵਾਂ", services_title: "ਸਾਡੇ ਲੈਬੋਰੇਟਰੀ ਟੈਸਟ",
    services_sub: "ਆਮ ਜਾਂਚ ਤੋਂ ਲੈ ਕੇ ਖਾਸ ਡਾਇਗਨੋਸਟਿਕਸ ਤੱਕ, ਸਭ ਇੱਕ ਹੀ ਛੱਤ ਹੇਠ।",
    search_placeholder: "ਆਪਣਾ ਲੈਬ ਟੈਸਟ ਖੋਜੋ…",
    hc_label: "ਘਰ ਵਿੱਚ ਸਹੂਲਤ", hc_title: "ਹੋਮ ਬਲੱਡ ਕਲੈਕਸ਼ਨ",
    hc_text: "ਇੰਤਜ਼ਾਰ ਵਿੱਚ ਸਮਾਂ ਬਰਬਾਦ ਨਾ ਕਰੋ। ਸਾਡੇ ਤਜਰਬੇਕਾਰ ਤਕਨੀਸ਼ੀਅਨ ਤੁਹਾਡੇ ਘਰੋਂ ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਬਲੱਡ ਸੈਂਪਲ ਲੈਂਦੇ ਹਨ।",
    how_label: "ਸੌਖੀ ਪ੍ਰਕਿਰਿਆ", how_title: "ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ",
    step1: "ਅਪੌਇੰਟਮੈਂਟ ਬੁੱਕ ਕਰੋ", step2: "ਹੋਮ ਕਲੈਕਸ਼ਨ", step3: "ਲੈਬੋਰੇਟਰੀ ਟੈਸਟਿੰਗ", step4: "ਡਿਜੀਟਲ ਰਿਪੋਰਟ ਪ੍ਰਾਪਤ ਕਰੋ",
    about_label: "ਸਾਡੇ ਬਾਰੇ", about_title: "ਜਿਸ 'ਤੇ ਤੁਸੀਂ ਭਰੋਸਾ ਕਰ ਸਕਦੇ ਹੋ",
    why_label: "ਕਿਉਂ DOABA", why_title: "DOABA ਡਾਇਗਨੋਸਟਿਕਸ ਕਿਉਂ ਚੁਣੋ",
    reviews_label: "ਪ੍ਰਸ਼ੰਸਾ ਪੱਤਰ", reviews_title: "ਸਾਡੇ ਮਰੀਜ਼ ਕੀ ਕਹਿੰਦੇ ਹਨ",
    faq_label: "ਸਵਾਲ-ਜਵਾਬ", faq_title: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ",
    contact_label: "ਸੰਪਰਕ ਕਰੋ", contact_title: "ਸਾਨੂੰ ਮਿਲੋ ਜਾਂ ਸੰਪਰਕ ਕਰੋ",
    footer_hours: "ਕੰਮ ਦੇ ਘੰਟੇ", footer_quick: "ਤੁਰੰਤ ਲਿੰਕ", footer_contact: "ਸੰਪਰਕ",
    submit: "ਸਬਮਿਟ ਕਰੋ", sending: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...", share_review: "ਆਪਣੀ ਸਮੀਖਿਆ ਸਾਂਝੀ ਕਰੋ",
  },
};

export const LANGS = [
  { code: "en", label: "EN" },
  { code: "hi", label: "हिं" },
  { code: "pa", label: "ਪੰ" },
];

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("doaba_lang") || "en");
  const change = useCallback((code) => {
    setLang(code);
    localStorage.setItem("doaba_lang", code);
  }, []);
  const t = useCallback((key) => translations[lang]?.[key] ?? translations.en[key] ?? key, [lang]);
  return <LangContext.Provider value={{ lang, setLang: change, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
